export const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
export const ACCESS_TOKEN_EXPIRY = 'accessTokenExpiry';

export const getToken = () => localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
export const getTokenExpiry = () => localStorage.getItem(ACCESS_TOKEN_EXPIRY);

export const setToken = ({ key, expiry }) => {
  const expiryMs = new Date(expiry).getTime();
  localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, key);
  localStorage.setItem(ACCESS_TOKEN_EXPIRY, expiryMs);
};

export const removeToken = () => {
  localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
  localStorage.removeItem(ACCESS_TOKEN_EXPIRY);
};
